import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TranslateModule } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Tools } from 'src/app/classes/shared/tools';
import { ProjectService } from 'src/app/services/api/projects/project.service';
import { UserService } from 'src/app/services/api/users/user.service';

@Component({
  selector: 'app-guest-user',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatToolbarModule,
    TranslateModule
  ],
  templateUrl: './guest-user.component.html',
  styleUrls: ['./guest-user.component.scss']
})

export class GuestUserComponent implements OnInit, OnDestroy {
  guestUserForm!: FormGroup;
  private readonly destroy$ = new Subject<void>();

  constructor(private fb: FormBuilder,
    private userService: UserService,
    private projectService: ProjectService,
    private tools: Tools,
    private dialogRef: MatDialogRef<GuestUserComponent>) {
  }

  ngOnInit(): void {
    this.guestUserForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      firstName: ['', [Validators.required, Validators.minLength(2)]],
      lastName: ['', [Validators.required, Validators.minLength(2)]],
      company: ['', [Validators.required, Validators.minLength(2)]],
      job: ['', [Validators.required, Validators.minLength(2)]]
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  saveGuestUser(): void {
    if (this.guestUserForm.invalid) {
      this.guestUserForm.markAllAsTouched();
      return;
    }

    const password = this.tools.generatePassword();

    const guestUser = {
      ...this.guestUserForm.value,
      password,
      project: this.projectService.currentProjectValue
    };

    this.userService.addGuestUser(guestUser)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          if (res) {
            this.dialogRef.close({ addGuestUser: true });
          }
        },
        error: (error) => {
          console.error('Erreur lors de l\'ajout de l\'utilisateur invité:', error);
        }
      });
  }
}
